import { render, staticRenderFns } from "./Outside.vue?vue&type=template&id=51232728&scoped=true&"
import script from "./Outside.vue?vue&type=script&lang=js&"
export * from "./Outside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51232728",
  null
  
)

export default component.exports